import {
  Affix,
  Avatar,
  Button,
  Checkbox,
  Dropdown,
  DatePicker,
  Empty,
  Spin,
  Drawer,
  Layout,
  Menu,
  Icon,
  Breadcrumb,
  Row,
  Card,
  Col,
  Modal,
  Table,
  Input,
  Select,
  InputNumber,
  Tag,
  Tabs,
  Form,
  Upload,
  Tooltip,
  Popconfirm,
  message,
  notification,
  Radio
} from 'ant-design-vue'
import { AntdComponent } from 'ant-design-vue/types/component'
import { VueConstructor } from 'vue'

export default {
  install(Vue: VueConstructor): void {
    const components: typeof AntdComponent[] = [
      Affix,
      Avatar,
      Empty,
      Button,
      Spin,
      Checkbox,
      Drawer,
      Dropdown,
      DatePicker,
      Layout,
      Icon,
      Menu,
      Breadcrumb,
      Modal,
      Row,
      Col,
      Card,
      Table,
      Input,
      Select,
      InputNumber,
      Tag,
      Tabs,
      Form,
      Upload,
      Radio,
      Popconfirm,
      Tooltip,
      Select
    ]
    components.forEach(component => {
      component.install(Vue)
    })

    Vue.prototype.$confirm = Modal.confirm
    Vue.prototype.$message = message
    Vue.prototype.$notification = notification

    Spin.setDefaultIndicator({
      indicator: (h: Function) => {
        return h('a-icon', {
          props: {
            type: 'loading'
          },
          style: {
            fontSize: '24px',
            color: 'rgba(0, 0, 0, 0.65)'
          }
        })
      }
    })
  }
}
